import Repository from "@shared/services/api/abstracts/Repository";
import { PublicBaseSegmentSetSerializer } from "../types/seating-types";

export default class PublicBasedSegmentRepository extends Repository<
  Array<PublicBaseSegmentSetSerializer>
> {
  public readonly repositoryName = "PublicBasedSegmentRepository";

  public readonly endpoint = "/api/public/venues/segments/";
}
